const DeleteBussiness = ({ index, customers, deleteHandler }) => {
  const fun = (x) => {
    console.log("x", x);
  };
  return (
    <div
      className="modal fade"
      id={`deleteBussinessModal`}
      tabindex="-1"
      aria-labelledby="exampleModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header" style={{ justifyContent: "end" }}>
            <h5 dir="ltr" className="modal-title" id="exampleModalLabel3">
              حذف کسب و کار
            </h5>
            <button
              type="button"
              className="btn btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>

          <div className="modal-body modlatrashposition">
            <p>آیا کسب و کار مد نظر حذف شود؟</p>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary btn-sm"
              data-bs-dismiss="modal"
            >
              خیر
            </button>
            <button
              type="button"
              onClick={() => {
                deleteHandler(index);
              }}
              className="btn btn-danger btn-sm"
              data-bs-dismiss="modal"
            >
              بله
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeleteBussiness;
